import { JsonUtils } from '../../utils/json.util'
import { Address } from './address'
import { Questionnaire } from './questionnaire'

export enum PromotionStatus {
    PENDING = 'pending',
    PROMOTED = 'promoted',
    REJECTED = 'rejected'
}


export class PotentialPatient {

    // Person Data
    private _id: string | undefined
    private _name: string | undefined
    private _cpf: string | undefined
    private _contact: string | undefined
    private _address: Address | undefined
    private _updated_at: Date| undefined
    private _questionnaire: Questionnaire | undefined
    private _promotion_status: PromotionStatus | undefined


    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }

    get name(): string | undefined {
        return this._name
    }
    set name(value: string | undefined) {
        this._name = value
    }
    get cpf(): string | undefined {
        return this._cpf
    }
    set cpf(value: string | undefined) {
        this._cpf = value
    }
    get contact(): string | undefined {
        return this._contact
    }
    set contact(value: string | undefined) {
        this._contact = value
    }
    get address(): Address | undefined {
        return this._address
    }
    set address(value: Address | undefined) {
        this._address = value
    }
    get updated_at(): Date | undefined {
        return this._updated_at
    }
    set updated_at(value: Date| undefined) {
        this._updated_at = value
    }
    get questionnaire(): Questionnaire | undefined {
        return this._questionnaire
    }
    set questionnaire(value: Questionnaire | undefined) {
        this._questionnaire = value
    }
    get promotion_status(): PromotionStatus | undefined {
        return this._promotion_status
    }
    set promotion_status(value: PromotionStatus | undefined) {
        this._promotion_status = value
    }

    public fromJSON(json: any): PotentialPatient {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }
        // Person Data
        if (json.id !== undefined) {
            this.id = json.id
        }
        if (json.name !== undefined) {
            this.name = json.name
        }
        if (json.cpf !== undefined) {
            this.cpf = json.cpf
        }
        if (json.contact !== undefined) {
            this.contact = json.contact
        }
        if (json.address !== undefined) {
            this.address = json.address
        }
        if (json.updated_at !== undefined) {
            this.updated_at = json.updated_at
        }
        if (json.questionnaire !== undefined) {
            this.questionnaire = new Questionnaire().fromJSON(json.questionnaire)
        }
        if (json.promotion_status !== undefined) {
            this.promotion_status = json.promotion_status
        }
        return this
    }
    public toJSON(): any {
        return {
            id: this.id || undefined,
            name: this.name || undefined,
            cpf: this.cpf || undefined,
            contact: this.contact || undefined,
            updated_at: this.updated_at || undefined,
            address: this.address || undefined,
            questionnaire: this.questionnaire || undefined,
            promotion_status: this.promotion_status || undefined
        }
    }
}